export const IconLike = ({ ...props }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fillRule="evenodd"
      clipRule="evenodd"
      viewBox="0 0 24 24"
      width="1em"
      height="1em"
      {...props}
    >
      <path d="M13.027 9.671A2 2 0 0 0 15 12l4.16.002a1 1 0 0 1 .969 1.242l-1.5 5.999a1 1 0 0 1-.97.757H8v-7.299l2.904-3.63A5 5 0 0 0 12 5.948V4.793a2.49 2.49 0 0 1 1.397 2.66zM6.8 11l2.543-3.178A3 3 0 0 0 10 5.948V4.49c0-1.225 1.2-2.09 2.363-1.703a4.49 4.49 0 0 1 3.007 4.995L15 10l4.16.002a3 3 0 0 1 2.908 3.727l-1.5 5.999A3 3 0 0 1 17.658 22H5a3 3 0 0 1-3-3v-5a3 3 0 0 1 3-3zM6 13H5a1 1 0 0 0-1 1v5a1 1 0 0 0 1 1h1z" />
    </svg>
  );
};
